import { addDoc, collection, deleteDoc, doc, onSnapshot, Timestamp } from "firebase/firestore";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import UserEditForm from "../components/UserEditForm";
import { db } from "../network/firebaseConfig";


const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        role: "",
        department: "",
        monitorType: "",
        status: "active",
    });
    const [selectedUser, setSelectedUser] = useState(null); // 👈 new

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "users"), (snapshot) => {
            const allUsers = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setUsers(allUsers);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!form.name || !form.email || !form.role) {
                return toast.error("Name, Email, and Role are required");
            }
            await addDoc(collection(db, "users"), {
                ...form,
                createdAt: Timestamp.now(),
            });
            toast.success("User added successfully");
            setForm({
                name: "",
                email: "",
                phone: "",
                role: "",
                department: "",
                monitorType: "",
                status: "active",
            });
        } catch (err) {
            console.error(err);
            toast.error("Failed to save user");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this user?")) {
            try {
                await deleteDoc(doc(db, "users", id));
                toast.success("User deleted successfully");
            } catch (err) {
                console.error(err);
                toast.error("Failed to delete user");
            }
        }
    };

    if (loading) return <p>Loading users...</p>;

    return (
        <div className="max-w-5xl mx-auto p-6 relative">
            <h2 className="text-xl font-semibold mb-4">Add New User</h2>

            {/* Add User Form */}
            <form onSubmit={handleSubmit} className="space-y-4 mb-6">
                {/* same fields as before */}
                {/* ... */}
            </form>

            {/* Users Table */}
            <h2 className="text-xl font-semibold mb-2">All Users</h2>
            <table className="w-full table-auto border-collapse border border-gray-300">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="border p-2">Name</th>
                        <th className="border p-2">Email</th>
                        <th className="border p-2">Role</th>
                        <th className="border p-2">Department</th>
                        <th className="border p-2">Monitor Type</th>
                        <th className="border p-2">Status</th>
                        <th className="border p-2">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((u) => (
                        <tr key={u.id} className="hover:bg-gray-50">
                            <td className="border p-2">{u.name}</td>
                            <td className="border p-2">{u.email}</td>
                            <td className="border p-2">{u.role}</td>
                            <td className="border p-2">{u.department || "-"}</td>
                            <td className="border p-2">{u.monitorType || "-"}</td>
                            <td className="border p-2">{u.status}</td>
                            <td className="border p-2 space-x-2">
                                <button
                                    className="bg-teal-400 text-white px-2 py-1 rounded"
                                    onClick={() => setSelectedUser(u)} // 👈 open edit form
                                >
                                    Edit
                                </button>
                                <button
                                    className="bg-red-500 text-white px-2 py-1 rounded"
                                    onClick={() => handleDelete(u.id)}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Edit Modal */}
            {selectedUser && (
                <UserEditForm
                    selectedUser={selectedUser}
                    onClose={() => setSelectedUser(null)}
                />
            )}
        </div>
    );
};

export default UserManagement;

